import React from "react";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { calculateDaysInBetween, calculateOverdueColor } from "../services/helpers";

const OverdueCalculationComponent: React.FC<{ dueDate: Date; color?: string; component?: React.ElementType }> = ({
  dueDate,
  color,
  component = "p",
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const diffDays = calculateDaysInBetween(dueDate);
  const colorType = calculateOverdueColor(dueDate);

  const getStatusColor = (type: "success" | "error" | "warning") => {
    if (type === "success") return isDarkMode ? theme.palette.success.main : "#37C7AA";
    if (type === "error") return isDarkMode ? theme.palette.error.main : "#760000";
    if (type === "warning") return isDarkMode ? theme.palette.warning.main : "#E2AC00";
    return undefined;
  };

  if (colorType === "success") {
    return (
      <Typography variant="body2" component={component} color="inherit">
        Due in <strong style={{ color: color ?? getStatusColor("success") }}>{diffDays} days</strong>
      </Typography>
    );
  }

  if (colorType === "error") {
    return (
      <Typography variant="body2" component={component} color="inherit">
        Overdue <strong style={{ color: color ?? getStatusColor("error") }}>{Math.abs(diffDays)} days</strong>
      </Typography>
    );
  }

  if (diffDays === 0) {
    return (
      <Typography variant="body2" component={component} style={{ color: color ?? getStatusColor("warning") }}>
        Due today
      </Typography>
    );
  }

  return (
    <Typography variant="body2" component={component} color="inherit">
      Overdue <strong style={{ color: color ?? getStatusColor("warning") }}>{Math.abs(diffDays)} days</strong>
    </Typography>
  );
};

export default OverdueCalculationComponent;
